<template>
    <div
      class="projectstructure-filter" 
      :style="`
        ${depth !== 0?`background-color: ${background_color};`:''}
        ${nested_index === ''?'border: none;':''}
      `"
      >
      <!-- operator selector -->
      <template v-for="(object, obj_index) in filter_object">
        <!-- "bracket" -> nested filter object -->
        <ProjectStructureFilter
            v-if="Array.isArray(object)"
            :key="`${nested_index}object${obj_index}`"
            :filter_object="object"
            :parent_filter_object="filter_object"
            :parent_obj_index="obj_index"
            :nested_index="`${nested_index}_${obj_index}`"
            :depth="depth+1"
            :tree_type="tree_type"
            @changeLineComplete="$emit('changeLineComplete')"
            @changeOperator="$emit('changeOperator')"
            />
        <!-- operator between brackets-->
        <ProjectStructureFilterOperator
             v-else-if="object.type === 'operator'" 
            :key="`${nested_index}object${obj_index}`"
            :object="object"
            :obj_index="obj_index"
            @addFilterBracket="addFilterBracket($event.index, $event.after)"
            @addFilterLine="addFilterLine($event.index, $event.before)"
            @changeOperator="$emit('changeOperator')"
        />
        <!-- filter line -->
        <ProjectStructureFilterLine
            v-else 
            :key="`${nested_index}object${obj_index}`"
            :object="object"
            :background_color="background_color"
            :object_defaults_by_type="object_defaults_by_type"
            :tree_type="tree_type"
            @deleteFilterLine="deleteFilterLine(obj_index), $event === true && (nested_index !== '' || obj_index !== 0)?$emit('changeLineComplete'):''"
            @changeLineComplete="$emit('changeLineComplete')"
            />
    </template>
    <div class="projectstructure-filter-operator">
        <TTooltip value="Add filter brackets">
            <TIcon
                class="cursor-pointer" 
                v-if="filter_object.length !== 0"
                name="area-empty"
                @click.native="addFilterBracket(filter_object.length-1)"
                />
        </TTooltip>
        <TTooltip value="Add filter line">
            <TIcon
                class="cursor-pointer" 
                name="add-circle"
                @click.native="addFilterLine(filter_object.length-1)"
            />
        </TTooltip>
    </div>
    </div>
  </template>
  <script>
    import { mapGetters } from 'vuex';

    import ProjectStructureFilter from '@/components/ProjectStructureRework/ProjectStructureFilter.component.vue';
    import ProjectStructureFilterLine from '@/components/ProjectStructureRework/ProjectStructureFilterLine.component.vue';
    import ProjectStructureFilterOperator from '@/components/ProjectStructureRework/ProjectStructureFilterOperator.component.vue';
    import TIcon from '@/components/Taktify/TIcon.component.vue';
    import TTooltip from '@/components/Taktify/TTooltip.component.vue';
    
    export default {
      props: ['tree_type', 'filter_object', 'parent_filter_object', 'parent_obj_index', 'nested_index', 'depth'],
      name: 'ProjectStructureFilter',
      components: {
        ProjectStructureFilter,
        ProjectStructureFilterLine,
        ProjectStructureFilterOperator,
        TIcon,
        TTooltip,
      },
      data: () => ({
        type: "filter_attr", // filter_attr (direct attributes), filter_prop (prop in propset), filter_parent, filter_linked
        object_defaults_by_type: {
            spatial: {
                    filter_attr:{type: 'filter_attr', attributename: 'ifc_type', operator: '===', value: '', active: true},
                    filter_prop:{type: 'filter_prop', propsetname: '', propname: '', operator: '===', value: '', active: true},
                    filter_parent:{type: 'filter_parent', parent_type: 'projects', parent_id: -1, operator: 'includes', direct: true, active: true},
                    filter_linked:{type: 'filter_linked', link_type: 'taktareas', link_id: -1, operator: 'includes', direct: true, target: 'all', active: true}, //target as array??
                },
            process: {
                    filter_attr:{type: 'filter_attr', attributename: 'text', operator: '===', value: '', active: true},
                    filter_parent:{type: 'filter_parent', parent_type: 'projects', parent_id: -1, operator: 'includes', direct: true, active: true},
                    filter_linked:{type: 'filter_linked', link_type: 'elements', link_id: -1, operator: 'includes', direct: true, target: 'elements', active: true}, //target as array??
                }
        }
      }),
      computed: {
        ...mapGetters('ProjectStructure', [
            'getBackgroundColor',
        ]),
        background_color(){
            if (this.nested_index === '') {
                return 'rgb(45,45,45)';
            } else {
                return this.getBackgroundColor(this.depth);
            }
        },
      }, 
      methods: {
        deleteFilterLine(index) {
            if (this.nested_index === '' && this.filter_object.length === 1) {
                this.filter_object.splice(0,1,JSON.parse(JSON.stringify(this.object_defaults_by_type[this.tree_type].filter_attr)));
            } else if (this.nested_index !== '' && this.filter_object.length === 3) { // only 2 lines in brackets (and one operator)-> brackets auflösen
                let copy_index;
                if (index === 0) {
                    copy_index = 2;
                } else {
                    copy_index = 0;
                }
                this.parent_filter_object.splice(this.parent_obj_index,1, this.filter_object[copy_index]);
            } else if(index === 0) {
                this.filter_object.splice(index, 2);
            } else {
                this.filter_object.splice(index-1, 2);
            }
        },
        addFilterLine(index, before) {
            if (!before) {
                this.filter_object.splice(index+1, 0, JSON.parse(JSON.stringify(this.object_defaults_by_type[this.tree_type].filter_attr)));
                if (index+1 !== 0) {
                    this.filter_object.splice(index+1, 0, {type: 'operator', operator: "&&"});  
                }
            } else {
                this.filter_object.splice(index, 0, {type: 'operator', operator: "&&"});  
                this.filter_object.splice(index, 0, JSON.parse(JSON.stringify(this.object_defaults_by_type[this.tree_type].filter_attr)));

            }
        },
        addFilterBracket(index) {
            this.filter_object.splice(index, 1, [this.filter_object[index]]);
            this.filter_object[index].push({type: 'operator', operator: "&&"});  
            this.filter_object[index].push(JSON.parse(JSON.stringify(this.object_defaults_by_type[this.tree_type].filter_attr)));  
        },
      }
    }
  </script>
  <style>
    .projectstructure-filter {
        position: relative;
        display: flex;
        width: 100%;
        flex-direction: column;
        padding: 5px;
        border: 1px solid white;
        border-radius: 6px;
        /* overflow-x: hidden; */
        /* zoom: 0.9; */
    }
    .projectstructure-filter-operator {
        display: flex;
        width: 100%;
        justify-content: center;
        margin-top: 3px;
        margin-bottom: 3px;
    }
  </style>
  